import React from "react"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./FullImage.scss"

const FullImage = ({ section }) => {
  return (
    <Fade>
      <section>
        <figure
          className="full-image"
          style={{
            backgroundImage: `url(${
              section.image?.url ||
              "https://images.unsplash.com/photo-1638913660695-b490171d17c9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwyMTh8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
            })`,
          }}
        />
        {section.image?.caption && (
          <figcaption>{section.image?.caption}</figcaption>
        )}
      </section>
    </Fade>
  )
}

FullImage.propTypes = {
  section: PropTypes.object.isRequired,
}

export default FullImage
